import { Theme } from '@mui/material/styles';

const iconPadding = '0.375rem';

export const getMuiIconButton = (theme: Theme): Record<string, unknown> => ({
  MuiIconButton: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.common.black,
        minHeight: 'unset',
        padding: iconPadding,

        '&:hover': {
          backgroundColor: theme.palette.grey[200],

          '@media (hover: none)': {
            backgroundColor: theme.palette.grey[200],
          },

          [theme.breakpoints.up('sm')]: {
            backgroundColor: theme.palette.primary.main,
          },

          '& .fd-icon svg': {
            color: theme.palette.common.black,

            '@media (hover: none)': {
              color: theme.palette.common.black,
            },

            [theme.breakpoints.up('sm')]: {
              color: theme.palette.common.white,
            },
          },
        },

        '&:disabled': {
          backgroundColor: theme.palette.grey[200],

          '& .fd-icon svg': {
            color: theme.palette.grey[500],
          },
        },
      },

      colorSecondary: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        padding: iconPadding,

        '&:hover': {
          backgroundColor: theme.palette.primary.main,

          '& .fd-icon svg': {
            color: theme.palette.common.white,
          },

          '@media (hover: none)': {
            backgroundColor: theme.palette.common.white,
          },
        },

        '&:disabled': {
          backgroundColor: theme.palette.common.white,
        },
      },
    },
  },
});
